"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.defaultOrderByOptions = void 0;
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/sokosite/configModal");
exports.defaultOrderByOptions = {
    orderBy: 'name',
    order: 'asc'
};
exports.initialState = {
    isOpen: false,
    orderByOptions: Object.assign({}, exports.defaultOrderByOptions),
    searchString: '',
    filterOptions: {}
};
const isOpen = monocle.Lens.fromProp('isOpen');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const searchStringLens = monocle.Lens.fromProp('searchString');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
exports.methods = {};
exports.methods[ActionTypes.TOGGLE_MODAL] = (state) => {
    return isOpen.set(!isOpen.get(state))(state);
};
exports.methods[ActionTypes.CLEAR] = (state) => (Object.assign({}, exports.initialState));
exports.methods[ActionTypes.SET_ORDER_BY] = (state, action) => orderByOptionsLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_COLUMN_FILTER] = (state, action) => filterOptionsLens.modify((x) => {
    const clone = Object.assign({}, x);
    const { field, value } = action.payload;
    if (value === undefined) {
        delete clone[field];
    }
    else {
        clone[field] = value;
    }
    return clone;
})(state);
//# sourceMappingURL=configModal.js.map